import React from 'react';
import classes from "../MenuIdeaDetailPage.module.scss";

const HeroImage = (props) => {
    return (
        <div className={classes.Card_header_img}
             style={{backgroundImage: `url(${props.hero_image})`}}/>
    );
}

export default HeroImage;